module.exports = __webpack_public_path__ + "img/volume-mute.810b553d.svg";